import React, { useState, useEffect } from "react";
import { Card, CardContent, CardMedia, Typography, Button } from "@mui/material";
import { get } from "lodash";
import useAuth from "src/hooks/useAuth";
import API_SERVICE from "src/utils/axios";
import { completeStrapiData } from "src/strapiData";
import { useSelector } from "react-redux";
import typography from "src/theme/typography";
import { ICONS } from "src/modules/ui-elements/Icon";
import { showLoginPopupAtom } from "../editor-v2/Atoms";
import { useSetAtom } from "jotai";
export const NeedHelp = (props) => {
    const { getNotification } = props;
    const { handleClose } = props;
    const [jobOrderId, setJobOrderId] = useState();
    const [value, setValue] = useState(1);
    const [jobOrderLabel, setJobOrderLabel] = useState();
    const [genericChatCount, setGenericChatCount] = useState(0);
    const [userData, setUserData] = useState([]);
    const [ordersCount, setOrdersCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [iframeVisible, setIframeVisible] = useState(false);
    const { user } = useAuth();
    const setLoginPopupAtom = useSetAtom(showLoginPopupAtom);
    const { entireStrapiData } = useSelector((state) => state.strapi);
    const strapiData = entireStrapiData?.HelpCentreWebappComp;
    const currentDate = new Date();
    const twentyDaysAgo = new Date(
        currentDate.setDate(
            currentDate.getDate() - (process.env.NEXT_PUBLIC_CHAT_HIDE_AFTER_DAYS || 20)
        )
    );
    const feedbackChatTokenHandler = () => {
        const token = localStorage.getItem("accessToken");
        const wn = document.getElementById("feedback_Box").contentWindow;
        wn.postMessage(token, "*");
    };
    const sidebarStyle = {
        height: "618px",
        overflowY: "auto",
        position: "fixed",
        width: "364px",
        backgroundColor: "#F9F9F9",
        borderRadius: "8px",
        zIndex: "9999",
        boxShadow: "0px 3px 32px 0px rgba(38, 38, 38, 0.16)",
        right: 0,
        bottom: 0,
        margin: 16,
    };

    const pointer = {
        cursor: "pointer",
    };

    const buttonStyle = {
        background: "none",
        border: "none",
        cursor: "pointer",
    };
    const titleStyle = {
        background:
            "radial-gradient(3301.74% 163.80% at 0.00% -3.91%, rgba(95, 46, 235, 0.10) 0%, rgba(235, 46, 131, 0.10) 46.59%, rgba(240, 55, 80, 0.10) 78.30%)",
        padding: "16px",
        height: "55px",
        fontSize: "16px",
    };

    const cardStyle = {
        padding: "16px",
        margin: "16px",
        height: "120px",
        width: "330px",
        borderRadius: "8px",
        cursor: "pointer",
    };
    const cardContentContainerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0px",
        fontSize: "14px",
    };

    const cardContentStyle = {
        flexGrow: 1,
        padding: "0px",
        maxWidth: "186px",
    };
    const textStyle = {
        ...typography.subtitle2,
        marginBottom: "10px",
        textOverflow: "ellipsis",
        overflow: "hidden",
    };
    const btnStyle = {
        marginBottom: "10px",
        cursor: "pointer",
    };
    const iconStyle = {
        fontSize: "24px",
        verticalAlign: "middle",
        marginLeft: "20px",
    };
    const getOrderDetails = async () => {
        const userId = get(user, ["user", "_id"], "");
        const baseUrl = process.env.NEXT_PUBLIC_API_URL_V2;
        const data = await API_SERVICE.get(
            `${baseUrl}v1/api/chat/getRecentTicket/0/25/?userId=${userId}`
        );
        setUserData(data.data.data);
        let sum = 0;
        const totalUserCount = data.data.data.reduce(
            (sum, item) => sum + +item.unreadChatCount,
            sum
        );
        setOrdersCount(totalUserCount);
    };
    const getChatDetails = async () => {
        await API_SERVICE.get(
            `${process.env.NEXT_PUBLIC_API_URL_V2}v1/api/chat/getExternalChatUnreadCount`
        ).then((response) => {
            setGenericChatCount(response.data.data.genericChat);
            const val = ordersCount + genericChatCount;
            setTotalCount(val);
        });
    };

    useEffect(() => {
        getOrderDetails(), getChatDetails(), getNotification();
    }, [value]);
    return (
        <div style={sidebarStyle} onClick={e => {
          e.stopPropagation();
        }}>
            {value === 1 ? (
                <>
                    <div
                        style={{ ...titleStyle, display: "flex", justifyContent: "space-between" }}
                    >
                        {strapiData?.HelpCentreHeading || "Help Center"}
                        <div onClick={handleClose} style={pointer}>
                            <img src="/icons/cross-dark.svg" height="24px" width="24px" />
                        </div>
                    </div>
                    <Card
                        style={{ ...cardStyle, cursor: "pointer" }}
                        onClick={() => {
                            if (user?.user?.login_type === "Guest") {
                                setLoginPopupAtom(true);
                                handleClose();
                            } else {
                                setValue(2);
                            }
                        }}
                    >
                        <CardContent style={cardContentContainerStyle}>
                            <CardMedia
                                component="img"
                                style={styles.iconStyle2}
                                image={
                                    strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[0]
                                        ?.Icon || ICONS.orderDark
                                }
                            />
                            <div style={styles.contentStyle}>
                                <Typography sx={{ ...typography.subtitle2, ...btnStyle }}>
                                    {strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[0]
                                        ?.Heading || "Project Related"}
                                </Typography>
                                <Typography sx={typography.subtitle3}>
                                    {strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[0]
                                        ?.Description ||
                                        "Click here for your order related queries"}
                                </Typography>
                                {ordersCount > 0 ? (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "-17%",
                                            transform: "translate(-50%,-50%)",
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            backgroundColor: "#F3485D",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {ordersCount}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>

                            <div
                                style={{
                                    ...buttonStyle,
                                    justifyContent: "flex-end",
                                    flexDirection: "column",
                                }}
                            >
                                <img
                                    src={
                                        user?.user?.login_type === "Guest"
                                            ? ICONS.lockGradient
                                            : "/icons/chevron-right.svg"
                                    }
                                    alt="Right Image"
                                    style={{
                                        fontSize: "24px",
                                        verticalAlign: "middle",
                                        marginLeft:
                                            user?.user?.login_type === "Guest" ? "0px" : "20px",
                                        height:
                                            user?.user?.login_type === "Guest" ? "20px" : "10px",
                                    }}
                                />
                            </div>
                        </CardContent>
                    </Card>
                    {user?.user?.login_type !== "Guest" && (
                        <Card
                            style={{ ...cardStyle, cursor: "pointer" }}
                            onClick={() => {
                                setValue(4);
                                setIframeVisible(true);
                            }}
                        >
                            <CardContent style={styles.containerStyle}>
                                <CardMedia
                                    component="img"
                                    style={styles.iconStyle}
                                    image={
                                        strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[1].Icon || ICONS.chatDark
                                    }
                                />
                                <div style={styles.contentStyle}>
                                    <Typography
                                        sx={{ ...typography.subtitle2, marginBottom: "10px" }}
                                    >
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[1].Heading ||
                                            "Chat with Us!"}
                                    </Typography>
                                    <Typography sx={typography.subtitle3}>
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[1].Description ||
                                            "Offers and updates"}
                                    </Typography>
                                    {genericChatCount > 0 ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "-17%",
                                                transform: "translate(-50%,-50%)",
                                                width: "24px",
                                                height: "24px",
                                                borderRadius: "50%",
                                                backgroundColor: "#F3485D",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {genericChatCount}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                <img
                                    src="/icons/chevron-right.svg"
                                    style={{
                                        fontSize: "24px",
                                        verticalAlign: "middle",
                                        marginLeft: "20px",
                                    }}
                                />
                            </CardContent>
                        </Card>
                    )}
                    <a
                        href="https://www.domyshoot.com/tutorial"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Card style={cardStyle}>
                            <CardContent style={styles.containerStyle}>
                                <CardMedia
                                    component="img"
                                    style={styles.iconStyle}
                                    image={
                                        strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[2]?.Icon || ICONS.playDark
                                    }
                                />
                                <div style={styles.contentStyle}>
                                    <Typography
                                        sx={{ ...typography.subtitle2, marginBottom: "10px" }}
                                    >
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[2]?.Heading ||
                                            "Getting Started"}
                                    </Typography>
                                    <Typography sx={typography.subtitle3}>
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[2]?.Description ||
                                            "Learn more about DoMyShoot"}
                                    </Typography>
                                </div>
                                <img
                                    src="/icons/chevron-right.svg"
                                    alt="Right Image"
                                    style={{
                                        fontSize: "24px",
                                        verticalAlign: "middle",
                                        marginLeft: "20px",
                                    }}
                                ></img>
                            </CardContent>
                        </Card>
                    </a>
                    <a
                        href="https://www.domyshoot.com/faq"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Card style={cardStyle}>
                            <CardContent style={styles.containerStyle}>
                                <CardMedia
                                    component="img"
                                    style={styles.iconStyle}
                                    image={
                                        strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[3]?.Icon || ICONS.faqDark
                                    }
                                />
                                <div style={styles.contentStyle}>
                                    <Typography
                                        sx={{ ...typography.subtitle2, marginBottom: "10px" }}
                                    >
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[3]?.Heading || "FAQs"}
                                    </Typography>
                                    <Typography sx={typography.subtitle3}>
                                        {strapiData?.HelpCentreWebappComp
                                            ?.HelpCentreOptionWebapp?.[3]?.Description ||
                                            "Get answers here"}
                                    </Typography>
                                </div>
                                <img
                                    src="/icons/chevron-right.svg"
                                    alt="Right Image"
                                    style={{
                                        fontSize: "24px",
                                        verticalAlign: "middle",
                                        marginLeft: "20px",
                                        marginRight: "10px",
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </a>
                </>
            ) : value === 2 ? (
                <>
                    <div style={titleStyle}>
                        <button
                            onClick={() => {
                                setValue(1);
                            }}
                            style={buttonStyle}
                        >
                            <img
                                src="/images/back.svg"
                                alt="Right Image"
                                style={{
                                    fontSize: "24px",
                                    verticalAlign: "middle",
                                    marginRight: "20px",
                                    cursor: "pointer",
                                }}
                            />
                        </button>
                        {strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[0]?.Heading ||
                            "Project Related"}
                    </div>
                    <div>
                        {userData && userData.length > 0 ? (
                            userData
                                .filter((data) => new Date(data.update_date) >= twentyDaysAgo)
                                .map((data) => (
                                    <Card
                                        key={data._id}
                                        style={cardStyle}
                                        onClick={() => {
                                            setJobOrderLabel(data?.job_order_id?.name);
                                            setJobOrderId(data?.job_order_id?._id);
                                            setValue(3);
                                        }}
                                    >
                                        <CardContent style={cardContentContainerStyle}>
                                            <div
                                                style={{
                                                    marginTop: "0px",
                                                    height: "60px",
                                                    width: "60px",
                                                    marginRight: "10px",
                                                    objectFit: "contain",
                                                }}
                                            >
                                                <CardMedia
                                                    component="img"
                                                    image={
                                                        data.job_order_id.upload_structure
                                                            .folders[0].banner_image
                                                    }
                                                />
                                            </div>
                                            <div style={cardContentStyle}>
                                                <Typography sx={textStyle}>
                                                    {data.job_order_id.name}
                                                </Typography>
                                                <Typography sx={typography.subtitle3}>
                                                    {data.createdAt.split("T")[0]}
                                                </Typography>
                                            </div>
                                            {data.unreadChatCount > 0 && (
                                                <div
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#F3485D",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {data.unreadChatCount}
                                                </div>
                                            )}
                                            <Button
                                                style={{
                                                    marginRight: "-10px",
                                                    marginLeft: "-40px",
                                                }}
                                            >
                                                <img
                                                    src="/icons/chevron-right.svg"
                                                    alt="Right Image"
                                                    style={{
                                                        fontSize: "24px",
                                                        verticalAlign: "middle",
                                                        marginLeft: "20px",
                                                        marginRight: "-25px",
                                                    }}
                                                />
                                            </Button>
                                        </CardContent>
                                    </Card>
                                ))
                        ) : (
                            <div
                                style={{
                                    margin: "40%",
                                    alignItems: "center",
                                    display: "inline-flex",
                                    flexDirection: "column",
                                }}
                            >
                                <svg
                                    width="94"
                                    height="79"
                                    viewBox="0 0 94 79"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.23858 17.22L1.99858 12C1.99858 8.8174 3.26286 5.76515 5.5133 3.51472C7.76373 1.26428 10.816 0 13.9986 0H36.0306C39.2129 0.000679649 42.2647 1.26541 44.5146 3.516L49.4826 8.484C51.7325 10.7346 54.7842 11.9993 57.9666 12H81.8586C83.5261 11.9998 85.1754 12.3472 86.7011 13.0199C88.2269 13.6927 89.5958 14.6761 90.7203 15.9073C91.8449 17.1386 92.7005 18.5907 93.2326 20.1711C93.7646 21.7514 93.9615 23.4253 93.8106 25.086L92.2746 42H86.2386L87.8286 24.54C87.9035 23.7104 87.805 22.8743 87.5391 22.0849C87.2732 21.2955 86.8459 20.5701 86.2843 19.9549C85.7227 19.3397 85.0392 18.8481 84.2772 18.5116C83.5152 18.175 82.6916 18.0008 81.8586 18H12.1386C11.3051 18 10.4807 18.1736 9.71807 18.5098C8.95539 18.8459 8.27113 19.3374 7.7089 19.9527C7.14666 20.5679 6.71879 21.2936 6.45256 22.0835C6.18632 22.8733 6.08756 23.7099 6.16258 24.54L9.98458 66.54C10.1193 68.0308 10.8064 69.4173 11.9109 70.4275C13.0155 71.4377 14.4577 71.9986 15.9546 72H52.9986V78H15.9546C12.9608 77.9988 10.0756 76.8786 7.86536 74.8593C5.65513 72.84 4.27951 70.0675 4.00858 67.086L0.186577 25.086C-0.0691053 22.3067 0.656942 19.5256 2.23858 17.226V17.22ZM40.2726 7.758C39.1476 6.6327 37.6217 6.00034 36.0306 6H13.9986C12.4268 5.99972 10.9177 6.61618 9.79574 7.71686C8.67374 8.81754 8.02844 10.3145 7.99858 11.886L8.03458 12.72C9.31858 12.252 10.6986 12 12.1386 12H44.5146L40.2726 7.758Z"
                                        fill="url(#paint0_linear_10_846)"
                                    />
                                    <path
                                        d="M70.1222 54.8777C69.5589 54.3151 68.7952 53.9994 67.9991 54C67.203 54.0006 66.4397 54.3173 65.8772 54.8807C65.3147 55.444 64.9989 56.2077 64.9995 57.0038C65.0001 57.7999 65.3169 58.5631 65.8802 59.1257L72.7562 66.0017L65.8802 72.8777C65.6013 73.1562 65.3799 73.487 65.2288 73.851C65.0777 74.2151 64.9998 74.6054 64.9995 74.9996C64.9989 75.7956 65.3147 76.5594 65.8772 77.1227C66.4397 77.686 67.203 78.0028 67.9991 78.0033C68.7952 78.0039 69.5589 77.6882 70.1222 77.1257L76.9982 70.2437L83.8742 77.1257C84.4375 77.689 85.2015 78.0055 85.9982 78.0055C86.7948 78.0055 87.5589 77.689 88.1222 77.1257C88.6855 76.5624 89.002 75.7983 89.002 75.0017C89.002 74.205 88.6855 73.441 88.1222 72.8777L81.2402 66.0017L88.1222 59.1257C88.6855 58.5631 89.0023 57.7999 89.0028 57.0038C89.0034 56.2077 88.6877 55.444 88.1252 54.8807C87.5627 54.3173 86.7994 54.0006 86.0033 54C85.2072 53.9994 84.4435 54.3151 83.8802 54.8777L76.9982 61.7597L70.1222 54.8777Z"
                                        fill="url(#paint1_linear_10_846)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_10_846"
                                            x1="47.4441"
                                            y1="1.55087"
                                            x2="13.9986"
                                            y2="46.434"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#EC008C" />
                                            <stop offset="1" stopColor="#F3485D" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_10_846"
                                            x1="85.2086"
                                            y1="46.4567"
                                            x2="53.2785"
                                            y2="80.1983"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#EC008C" />
                                            <stop offset="1" stopColor="#F3485D" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <div>No Project</div>
                            </div>
                        )}
                    </div>
                </>
            ) : value === 3 ? (
                <>
                    <div
                        style={{
                            background: "#fff",
                            width: "100%",
                            height: "fit-content",
                            zIndex: 5,
                        }}
                    >
                        <div style={{ ...titleStyle, zIndex: 10 }}>
                            <button
                                onClick={() => {
                                    setValue(2);
                                }}
                                style={buttonStyle}
                            >
                                <img
                                    src="/images/back.svg"
                                    alt="Right Image"
                                    style={{
                                        fontSize: "24px",
                                        verticalAlign: "middle",
                                        marginRight: "20px",
                                    }}
                                />
                            </button>
                            {strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[1]
                                ?.Heading || "Chat with Us!"}
                        </div>
                    </div>
                    <iframe
                        id="feedback_Box"
                        src={`${
                            process.env.NEXT_PUBLIC_FEEDBACK_CHAT
                        }?mode="app"&jobOrderLabel="${jobOrderLabel}"&jobOrderId="${jobOrderId}"&user_identity="${
                            user?.user?.email || user?.user?.phone
                        }"&company_name="${user?.user?.name}"&userId="${
                            user?.user?._id
                        }"&chat_type="EXTERNAL"`}
                        style={{
                            width: "100%",
                            height: "102%",
                            border: "1px solid #FFFFFF",
                            zIndex: "-1",
                            filter: "brightness(98%)",
                            top: "-17px",
                            borderRadius: "8px",
                            position: "absolute",
                            maxHeight: "635px",
                            paddingTop: "66px",
                        }}
                        onLoad={feedbackChatTokenHandler}
                    ></iframe>
                </>
            ) : (
                " "
            )}
            {(value === 1 || value === 4) && (
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: iframeVisible ? "100%" : "0", // Show div only when iframe is visible
                        visibility: iframeVisible ? "visible" : "hidden",
                        transition: "visibility 0s, opacity 0.3s ease", // Smooth transition for visibility and opacity
                        display: "flex",
                        flexDirection: "column", // Stack elements (header and iframe) vertically
                        justifyContent: "flex-start", // Start from the top
                    }}
                >
                    <div
                        style={{
                            ...titleStyle,
                            position: "relative",
                            zIndex: 10,
                            marginBottom: "5px", // Give a small space below header to separate from iframe
                            padding: "10px", // Add padding to make the header look nice
                        }}
                    >
                        <button
                            onClick={() => {
                                setValue(1);
                                setIframeVisible(false); // Hide iframe when navigating back
                            }}
                            style={buttonStyle}
                        >
                            <img
                                src="/images/back.svg"
                                alt="Back Image"
                                style={{
                                    fontSize: "24px",
                                    verticalAlign: "middle",
                                    marginRight: "20px",
                                }}
                            />
                        </button>
                        {strapiData?.HelpCentreWebappComp?.HelpCentreOptionWebapp?.[1]?.Heading ||
                            "Chat with Us"}
                    </div>

                    {/* Iframe Section */}
                    <iframe
                        id="feedback_Box"
                        src={`${process.env.NEXT_PUBLIC_FEEDBACK_CHAT}?mode="app"&user_identity="${
                            user?.user?.email || user?.user?.phone
                        }"&userId="${user?.user?._id}"&chat_type="GENERIC"`}
                        style={{
                            width: "100%",
                            height: iframeVisible ? "calc(100% - 30px)" : "10", // Subtract 50px for header height (adjust if needed)
                            borderRadius: "8px",
                            border: "1px solid #FFFFFF",
                            position: "relative", // Position the iframe normally in the container
                            top: "0", // Ensure iframe is positioned right below the header
                            visibility: iframeVisible ? "visible" : "hidden", // Control visibility of iframe
                            opacity: iframeVisible ? 1 : 0, // Fade-in effect
                            transition: "opacity 0.3s ease", // Smooth transition for fade-in effect
                            display: iframeVisible ? "block" : "none", // Ensure iframe takes space when visible
                        }}
                        onLoad={feedbackChatTokenHandler}
                    />
                </div>
            )}
        </div>
    );
};

const styles = {
    iconStyle: {
        marginTop: "-22%",
        width: "24px",
        height: "24px",
    },
    iconStyle2: {
        marginTop: "-17%",
        width: "24px",
        height: "24px",
    },
    contentStyle: {
        flexGrow: 1,
        padding: "0px",
        maxWidth: "210px",
        height: "100%",
        position: "relative",
    },
    containerStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0px",
        fontSize: "14px",
        height: "100%",
    },
};
